import React, { useState } from "react";
import { Alert, Button, Form, FormGroup, Input, Label } from "reactstrap";
import { useAuth } from "./useAuth";

// ADC's own sign-in form. The password goes to Flask, which checks it against
// Logto (backend/session.py). Accounts are created by an administrator, so
// there is no register link; a forgotten password is reset by an admin on the
// Users page.
export const Login = () => {
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await signIn(email.trim(), password);
    } catch (caught) {
      setError(caught.message);
      setPassword("");
      setSubmitting(false);
    }
    // On success this component unmounts as the app takes over.
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#F7F7FA",
        padding: "16px",
      }}
    >
      <Form
        onSubmit={onSubmit}
        data-testid="login-form"
        style={{
          width: "100%",
          maxWidth: "360px",
          background: "#FFF",
          border: "1px solid #E0E0E0",
          borderRadius: "8px",
          padding: "32px 28px",
          fontSize: "13px",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <img src="new.png" alt="Agtuall" style={{ height: "40px" }} />
        </div>
        <FormGroup>
          <Label for="login-email">Email</Label>
          <Input
            id="login-email"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={submitting}
            autoFocus
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="login-password">Password</Label>
          <Input
            id="login-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={submitting}
            required
          />
        </FormGroup>
        {error ? (
          <Alert color="danger" style={{ fontSize: "13px" }} data-testid="login-error">
            {error}
          </Alert>
        ) : null}
        <Button
          type="submit"
          block
          disabled={!email || !password || submitting}
          style={{ background: "#4A42A0", borderColor: "#4A42A0" }}
        >
          {submitting ? "Signing in..." : "Sign in"}
        </Button>
        <div style={{ marginTop: "16px", color: "#757575", textAlign: "center" }}>
          Forgot your password? Ask an administrator to reset it.
        </div>
      </Form>
    </div>
  );
};
